import { DEFAULT_PAGE_SIZE } from '@/commons/constants';
import { convertObjectToQueryString } from '@/utils';
import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';

export const criteriaParams = {
  page: 'page',
  size: 'size',
  keyword: 'keyword',
  published: 'published',
  type: 'type',
  chatbotId: 'chatbotId',
};

export const getUrlParamsFromCriteria = (criteria, query) => {
  Object.keys(criteriaParams).forEach((param) => {
    if (
      criteria &&
      criteria[param] !== undefined &&
      criteria[param] !== null &&
      !(criteria[param] instanceof Object)
    ) {
      query[param] = criteria[param];
    } else if (criteria && Array.isArray(criteria[param])) {
      query[param] = criteria[param].join();
    } else {
      delete query[param];
    }
  });
  return query;
};

type Props = {
  criteria: any;
  onInitPage: any;
};

const useQueryCriteria = (props: Props) => {
  const { criteria, onInitPage } = props;
  const location: any = useLocation();
  const history: any = useHistory();

  const handleOnInitPage = async () => {
    const data = { size: DEFAULT_PAGE_SIZE };

    Object.keys(criteriaParams).forEach((param) => {
      if (location.query[param]) {
        data[param] = location.query[param];
      }
    });

    onInitPage(data);
  };

  useEffect(() => {
    const query = getUrlParamsFromCriteria(criteria, {
      ...location.query,
    });
    history.replace({
      query,
      pathname: location.pathname,
      search: convertObjectToQueryString(query),
      state: {
        update: true,
      },
    });
  }, [criteria]);

  useEffect(() => {
    handleOnInitPage();
  }, []);

  return {};
};

export default useQueryCriteria;
